import React, { FC } from 'react';
import { graphql } from 'gatsby';
import { MDXRenderer } from 'gatsby-plugin-mdx';

import Header from 'src/components/Header';
import Layout from 'src/components/Layout';
import Footer from 'src/components/Footer';
import { HeadingScope } from 'src/components/Heading';

interface ImpressumProps {
  data: any;
}

const Impressum: FC<ImpressumProps> = ({ data }) => {
  const { body } = data.content;

  return (
    <HeadingScope>
      <Header isWhite />
      <Layout layout="Inner-page">
        <MDXRenderer>{body}</MDXRenderer>
      </Layout>
      <Footer />
    </HeadingScope>
  );
};

export default Impressum;

export const query = graphql`
  query Impressum {
    content: mdx(slug: { eq: "impressum/" }) {
      body
    }
  }
`;
